import { render } from "./BrowseFilterBar.vue?vue&type=template&id=0134b679&scoped=true"
import script from "./BrowseFilterBar.vue?vue&type=script&lang=js"
export * from "./BrowseFilterBar.vue?vue&type=script&lang=js"

import "./BrowseFilterBar.vue?vue&type=style&index=0&id=0134b679&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0134b679"]])

export default __exports__